
export const DATE_FORMAT_DISPLAY = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT_DISPLAY = `${DATE_FORMAT_DISPLAY} HH:mm`;
export const DATE_TIME_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const DATE_FORMAT_API = 'YYYY-MM-DD';